import axios from 'axios'
import { url } from '@/components/common/common'

/**
 * 退出登录：调用后端 /login/logout 使 token 进入 Redis 黑名单并清理服务端登录态
 * 请求头 Authorization 携带 token，与全局 axios 拦截器(main.js)保持一致
 */
export function logout() {
  return axios.post(url + '/login/logout', null, {
    headers: { Authorization: window.localStorage.getItem('token') }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js